import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    padding: ${theme.spacing(2)}px;
  `,
  title: css`
    margin: ${theme.spacing(0, -1)};
    padding: ${theme.spacing(0, 1)};
    font-size: 13px;
    font-weight: 500;
    line-height: 24px;
    color: var(--colorScheme-textMinor, ${theme.go.schemes.colors.system.TextMinor});
    border-radius: 6px;
    background-color: var(--colorScheme-bgMinor, ${theme.go.schemes.colors.system.BgMinor});
  `,
  primary: css`
    font-size: 16px;
    line-height: 19px;
    color: var(--colorScheme-text, ${theme.go.schemes.colors.system.TextMain});
  `,
  secondary: css`
    font-size: 13px;
    line-height: 15px;
    color: var(--colorScheme-textMinor, ${theme.go.schemes.colors.system.TextMinor});
  `,
  item: css`
    padding-top: ${theme.spacing(2)}px;
    padding-bottom: ${theme.spacing(2)}px;
    border-bottom: 1px solid transparent;

    &:not(:last-child) {
      border-bottom-color: var(--colorScheme-line, #d2d0cc);
    }

    [dir='rtl'] & {
      text-align: right;
    }
  `,
}
